<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div class="page_main_sec">
        <div [formGroup]="frmQueryDashboard" *ngIf="frmQueryDashboard">
            <div class="row pd10">
                <div class="content_form_sec" *ngIf="showFilter">
                    <!-- <span *ngIf="showCloseIcon" class="close-btn filter-close" (click)="showFilter=false">x</span> -->
                    <div class="row">

                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <input matInput [placeholder]="'Invoice Number'" [formControlName]="'invoiceNumber'">
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <input matInput readonly [matDatepicker]="picker"
                                    [placeholder]="'Last Response Date To'" [formControlName]="'lastResponseDateTo'">
                                <mat-datepicker-toggle matSuffix [for]="picker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3">
                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Query Raised From</mat-label>
                                <mat-select [formControlName]="'queryRaisedFrom'">
                                    <mat-option [value]="option.id" *ngFor="let option of lstQueryRaisedFrom">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Query Status</mat-label>
                                <mat-select [formControlName]="'queryStatus'">
                                    <mat-option [value]="option.id" *ngFor="let option of lstQueryStatus">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <input matInput [placeholder]="'Payment Invoice Number'"
                                    [formControlName]="'paymentNumber'">
                            </mat-form-field>
                        </div>

                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <input matInput [placeholder]="'URN'" [formControlName]="'urn'">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="action_buttons">
                                <button type="button"
                                    class="btn primary_btn w120 waves-effect waves-light searchbtn smallButton"
                                    (click)="searchQuery()">Search</button>
                                <button type="button"
                                    class="btn secondary_btn w120 waves-effect waves-light resetButton"
                                    (click)="reset()">Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="lstSearchData.length>0">
            <app-basic-gridview [lstData]="lstSearchData" [gridTitle]="'Query List'" [hyperlinkCols]="lstLinkColumn"
                [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                [showPagination]="true" (cellClickEvent)="gridCellClickEvent($event)">
            </app-basic-gridview>
        </div>
    </div>
</div>

<ng-template #queryDetail let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Query</h5>
            <button type="button" class="close model_close_btn" (click)="closeQueryDetailModel()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row modaldivcontent" *ngFor="let msg of lstMessage;">
                <div class="col-lg-12 col-sm-12">
                    <div [ngClass]="msg.userId==currrentUserId?'currentUserStyle':'otherUserStyle'">
                        <div class="row">
                            <div class="col-lg-12">
                                <p><span style="font-weight: 600;">{{msg.userName}}</span> - <span
                                        style="font-size: 12px;">{{msg.userType}} &nbsp;&nbsp; {{msg.messageDateTime |
                                        date:'MMM dd yyyy h:MM a'}}</span>
                                    <span *ngIf="msg.attachment!=''" class="attach_icon_style">
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <img (click)="openAttachment(msg.attachmentData)"
                                            src="../../../assets/img/transaction/attach-icon.png" alt="Attach">
                                    </span>
                                </p>
                                <div class="attach_icon_area">
                                    <p>{{msg.message}}</p>
                                </div>
                            </div>
                            <!-- <div *ngIf="msg.attachment!=''" class="col-lg-1">
                                <div class="attach_icon_style">
                                    <img (click)="openAttachment(msg.attachmentData)"
                                        src="../../../assets/img/transaction/attach-icon.png" alt="">
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-6 col-sm-12">
                    <div *ngIf="msg.userId==currrentUserId">
                        <div class="col-lg-12 col-sm-12">
                            <p>{{msg.userName}} - {{msg.userType}} &nbsp;&nbsp; <span style="font-size: 12px;">{{msg.messageDateTime | date:'MMM dd yyyy h:MM a'}}</span> </p>
                            <div class="attach_icon_area">
                                <p>{{msg.message}}</p>
                                <div *ngIf="msg.attachment!=''"  class="attach_icon_style">
                                    <img (click)="openAttachment(msg.attachmentData)"
                                        src="../../../assets/img/transaction/attach-icon.png"
                                        alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="modal-footer">
            <div class="comment-box-main">
                <div class="row cmnt_sec_h_100">
                    <div class="col-lg-6 col-sm-6 cmnt_sec_h_100">
                        <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                          <label>Comments</label><span class="expand_textarea_sec" (click)="isCommentExpand = !isCommentExpand">
                                <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                            </span>
                            <span class="textarea_editor_main_sec">
                                <span class="words_count_limit">
                                    1000
                                </span>
                            </span>
                            <textarea [(ngModel)]="queryMessage" maxlength="1000" class="cmnt_textarea"></textarea>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <div class="row">
                            <div class="col-lg-8 col-sm-12">
                                <div class="browsefile_main_section" title="Select supporting file.">
                                    <input [type]="fileControlType" #supportingfileUpload
                                        id="uploadFileName" (change)="onSelectSupportedFile($event)"
                                        [(ngModel)]="selectedFile" />
                                    <div class="browse_file_sec">
                                        <img src="../../../assets/img/transaction/cloud-upload-alt.png" alt="Browse File" />
                                        <span>Drag & Drop Files</span>
                                    </div>
                                    <div class="browser_or_sec">
                                        <span>Or</span>
                                    </div>
                                    <div class="browse_file_sec">
                                        <img src="../../../assets/img/transaction/folder-open-solid.png" alt="Browse File">
                                        <span>Browse File</span>
                                    </div>
                                </div>
                                <div class="browsed_files_status_sec" *ngIf="supportingFileName!=''">
                                    <div class="file_status_sec">
                                        <img src="../../../assets/img/transaction/file_uploaded.png"
                                            class="file_uploaded_icon" alt="File Upload">
                                        <div class="file_name_sec">
                                            <div class="file_name_detail">
                                                <span class="status_file_name">{{supportingFileName}}</span>
                                                <img src="../../../assets/img/transaction/view.png"
                                                    class="files_action_icon" alt="View">
                                                <img (click)="deleteSupportedFile()"
                                                    src="../../../assets/img/transaction/delete.png"
                                                    class="files_action_icon file_status_delete" alt="Delete">
                                            </div>
                                            <div class="file_status_bar"></div>
                                        </div>
                                        <span class="file_checked_icon">
                                            <img src="../../../assets/img/transaction/checked.png" alt="Check">
                                        </span>
                                    </div>
                                </div>
                                <div class="browsed_files_status_sec" *ngIf="supportingFileName==''">
                                    <div class="file_status_sec">
                                        <span class="supportingFileText">
                                            Supporting file type {{supportingFileType}}. Max. file size
                                            {{supportingFileSize}}MB.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-8">
                                <button type="button" class="btn smallButton" (click)="sendQueryMessage()">
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
